import React from 'react';
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function SafetyReportArtifactAdvancedBanner({ reportId }: { reportId: string }) {
  const navigate = useNavigate();
  return (
    <Alert severity="info" sx={{ mb: 2 }} data-testid="artifact-advanced-package-banner">
      This is the advanced technical package, not the Safety Scan report.
      {' '}
      <Button
        size="small"
        onClick={() => navigate(`/acceptance/scans/${encodeURIComponent(reportId)}/verify`)}
        data-testid="artifact-open-canonical-scan"
      >
        Open Safety Scan report
      </Button>
    </Alert>
  );
}
